import { derived, readable, type Readable } from 'svelte/store';

import type { DynamicConfigOptions } from '@/teoCore/DynamicConfig';
import { TeoCore } from '@/teoCore/TeoCore';

export function useCoreStore() {
  return TeoCore.instance.store;
}

export function useCoreStateAnalysisUsageQuota() {
  return derived(TeoCore.instance.store, (state) => state.analysisUsageQuota);
}

export function useCoreStateAnalysisUsageQuotaInfo() {
  return derived(useCoreStateAnalysisUsageQuota(), (v) => {
    if (v?.total && v.total <= 0) return null;
    const used = Math.min(v.total, v.used ?? 0);
    return {
      text: `[${v.total - used}/${v.total}]`,
      depleted: used >= v.total,
      total: v.total,
      used: v.used,
    };
  });
}

let dynamicConfigReadable: Maybe<Readable<DynamicConfigOptions>>;

export function useDynamicConfig(): Readable<DynamicConfigOptions> {
  if (!dynamicConfigReadable) {
    dynamicConfigReadable = readable(TeoCore.instance.dynamicConfig.options, (set) => {
      function update() {
        set(TeoCore.instance.dynamicConfig.options);
      }
      TeoCore.instance.dynamicConfig.addEventListeners({
        alwaysCheckBrandFit: update,
        brandFitEnabled: update,
        evaluationProfileId: update,
        subscriptionName: update,
        textConfigOptions: update,
        textGeneratorEnabled: update,
        useExpParser: update,
        whitelistEnabled: update,
      });
    });
  }
  return dynamicConfigReadable;
}
